import React, { Component } from 'react';
import { observer } from 'mobx-react';
import VimeoVideoUploadService from '../services/VimeoVideoUploadService';
import Dialog from './Dialog';
import Row from './Row';
import Column from './Column';
import LinearProgress from './LinearProgress';
import Separator from './Separator';
import { toJS } from 'mobx';

class VimeoVideoUploadDialogContainer extends Component {
  render() {
    return (
      <Dialog title="Video upload progress" isOpen={toJS(VimeoVideoUploadService.isOpen)} actions={[]}>
        <Row>
          <Column size={12}>
            <LinearProgress
              value={toJS(VimeoVideoUploadService.uploadPercentage) || 0}
              color={toJS(VimeoVideoUploadService.uploadPercentage) >= 100 ? 'green' : 'blue'}
              showInfo
            />
            <Separator size="lg" />
          </Column>
        </Row>
      </Dialog>
    );
  }
}

export default observer(VimeoVideoUploadDialogContainer);
